import React, {Fragment, useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../store/actions/toggleModalActions';
import {
    deleteSensor,
    detachSensorAlertRule,
    detachSensorCalibrationValue,
    getAlertRulesForSensor,
    getSensorCalibrationValues,
    resetSensor,
    saveSensorAlertRule,
    saveSensorCalibrationValue,
    saveSensorType,
    getWarmTemperatureConfigListForSensor,
    detachWarmTemperatureConfig,
    saveWarmTemperatureConfig,
    getColdTemperatureConfigListForSensor,
    saveColdTemperatureConfig,
    detachColdTemperatureConfig,
    saveVapourPressure,
    getSensorStabilityReport, getSensorGatewayStats, updateMeasurements, updateMeasurementsRequest,
    getSoilTypes, updateSensorSoilType, removeSensorSoilType,
} from '../store/actions/sensorsActions';
import {
    getStatusColor,
    isCompanyAdmin, isCompanyUser,
    isCustomer,
    isDemoUser,
    isDistributorAdmin,
    isSuperAdmin
} from "../helpers/helpers";
import './SensorModal.scss';
import ExternalModal from "./_common/ExternalModal";
import ButtonSpinner from "./_common/ButtonSpinner";
import UserAccessModal from "./_common/UserAccessModal";
import ChangeLoraIdModal from "./ChangeLoraIdModal";
import ChangeTimePeriodModal from "./ChangeTimePeriodModal";
import Select from "react-select";
import {customStyles} from "../helpers/selectStyles";

import { useHistory } from "react-router-dom";
import {getInvoicesHistoryWithNIP} from "../store/actions/usersActions";
import EditSensorModal from "./EditSensorModal";
import RainSensorCountCorrectionModal from "./RainSensorCountCorrectionModal";

const copyToBuffer = value => {
    const text = String(value);

    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(textArea);
    return Promise.resolve(copied);
};

const selector = state => {
    const { language, disableButtons, sensors, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: sensors.selected,
        sensorTypes: sensors.sensorTypes,
        sensorAlertRules: sensors.sensorAlertRules,
        sensorAlertRulesOptions: sensors.sensorAlertRulesOptions,
        sensorsDetailsPending: sensors.sensorsDetailsPending,
        sensorsCalibrationDetailsPending: sensors.sensorsCalibrationDetailsPending,
        sensorCalibrationValues: sensors.sensorCalibrationValues,
        sensorTemperatureConfigs: sensors.sensorTemperatureConfigs,
        sensorTemperatureConfigsOptions: sensors.sensorTemperatureConfigsOptions,
        sensorColdTemperatureConfigs: sensors.sensorColdTemperatureConfigs,
        sensorColdTemperatureConfigsOptions: sensors.sensorColdTemperatureConfigsOptions,
        modalState: modalState
    }
};


const SensorModal = props => {
    const { sensor, fields, numberPerPage, filter, userId, details, reload,loadSensors, isTabletOrLess } = props;
    const { t, disableButtons, selected, sensorTypes, modalState, sensorsDetailsPending, sensorAlertRulesOptions, sensorCalibrationValues, sensorsCalibrationDetailsPending , sensorTemperatureConfigsOptions, sensorColdTemperatureConfigsOptions, } = useSelector(selector);
    const dispatch = useDispatch();
    const history = useHistory();
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [sensorResetConfirmation, setSensorResetConfirmation] = useState(false);
    const [sensorResetConfirmationMsg, setSensorResetConfirmationMsg] = useState(false);
    const [changeLoraModal, setChangeLoraModal] = useState(false);
    const [changeTimePeriodModal, setChangeTimePeriodModal] = useState(false)
    const [sensorType, setSensorType] = useState({id: sensor && sensor.nodeTypeId ? sensor.nodeTypeId : '', name: sensor && sensor.nodeTypeName ? sensor.nodeTypeName :
    ''});
    const [alertRule, setAlertRule] = useState(null);
    const [showSensorTypeOptions, setShowSensorTypeOptions] = useState(false);
    const [showAlertRulesOptions, setShowAlertRulesOptions] = useState(false);

    const [alertRulesSelectPending, setAlertRulesSelectPending] = useState(false);
    const [selectedMultiAlertRules, setSelectedMultiAlertRules] = useState([]);

    const [calibrationValuesPending, setCalibrationValuesPending] = useState(false);
    const [selectedMultiCalibrationValues, setSelectedMultiCalibrationValues] = useState([]);
    const [soilTypes, setSoilTypes] = useState([]);
    const [selectedSoilType, setSelectedSoilType] = useState(null);
    const [currentSoilType, setCurrentSoilType] = useState(sensor && sensor.soilType ? sensor.soilType : null);
    const [soilTypesPending, setSoilTypesPending] = useState(false);
    const [soilTypeChangePending, setSoilTypeChangePending] = useState(false);
    const [soilTypeConfirmation, setSoilTypeConfirmation] = useState(null);
    const [soilTypeMessage, setSoilTypeMessage] = useState(null);

    const [temperatureConfigPending, setTemperatureConfigPending] = useState(false)
    const [selectedTemperatureConfig, setSelectedTemperatureConfig] = useState(null)
    const [selectedColdTemperatureConfig, setSelectedColdTemperatureConfig] = useState(null)

    const [vapourPressurePending, setVapourPressurePending] = useState(false)
    const [vapourPressure, setVapourPressure] = useState(false)

    const [stabilityReportPending, setStabilityReportPending] = useState(false)
    const [stabilityReportData, setStabilityReportData] = useState(null)
    const [gatewayStatsModal, setGatewayStatsModal] = useState(false)
    const [gatewayStatsPending, setGatewayStatsPending] = useState(false)
    const [gatewayStatsData, setGatewayStatsData] = useState(null)
    const [gatewayStatsError, setGatewayStatsError] = useState(false)
    const [copiedGatewayIdentifier, setCopiedGatewayIdentifier] = useState(null)

    const [updateMeasurementsPending, setUpdateMeasurementsPending] = useState(false)
    const [rainSensorCorrectionModal, setRainSensorCorrectionModal] = useState(false)
    const [rainSensorCorrectionResult, setRainSensorCorrectionResult] = useState(null)


    const [editSensorModal, setEditSensorModal] = useState({active: false})
    const [sensorUsersAccessModal, setSensorUsersAccessModal] = useState(false)
    const isSoilMoistureSensor = sensor && (
        sensor.nodeTypeName === 'SOIL_MOISTURE_SENSOR' ||
        sensor.sensorType === 'SOIL_MOISTURE_SENSOR'
    );

    useEffect(() => {
        dispatch(getAlertRulesForSensor(sensor.id))
        dispatch(getSensorCalibrationValues(sensor.id))
        dispatch(getWarmTemperatureConfigListForSensor(sensor.id))
        dispatch(getColdTemperatureConfigListForSensor(sensor.id))
    },[])

    useEffect(() => {
        if (!isSoilMoistureSensor) return;

        let mounted = true;
        setSoilTypesPending(true);
        dispatch(getSoilTypes())
            .then(types => {
                if (!mounted) return;
                const options = types.map(type => ({...type, label: type.soilTypeName, value: type.soilType}));
                const assignedType = options.find(type =>
                    type.soilType === sensor.soilType ||
                    (!sensor.soilType && type.soilTypeName === sensor.soilTypeName)
                ) || null;
                setSoilTypes(options);
                setSelectedSoilType(assignedType);
                setCurrentSoilType(assignedType ? assignedType.soilType : null);
            })
            .catch(() => {
                if (mounted) setSoilTypeMessage({type: 'error', text: t.gettext('Could not load soil types')});
            })
            .finally(() => {
                if (mounted) setSoilTypesPending(false);
            });

        return () => { mounted = false; };
    }, [dispatch, isSoilMoistureSensor, sensor.id, sensor.soilType, sensor.soilTypeName, t]);

    useEffect(() => {
        if(sensor && sensor.vapourPressure) {
            setVapourPressure(sensor.vapourPressure ? sensor.vapourPressure : false)
        }
    }, [sensor]);


    useEffect(() => {
        if(sensorAlertRulesOptions && sensorAlertRulesOptions.length > 0) {
            const filteredAlerts = sensorAlertRulesOptions.filter(x => x.connectedToCurrentSensor)
            setSelectedMultiAlertRules(filteredAlerts)
        } else {
            setSelectedMultiAlertRules(null)
        }
    },[sensorAlertRulesOptions])

    useEffect(() => {
        if(sensorCalibrationValues && sensorCalibrationValues.length > 0) {
            const filteredCalibrations = sensorCalibrationValues.filter(x => x.isConnectedToCurrentSensor)
            setSelectedMultiCalibrationValues(filteredCalibrations)
        } else {
            setSelectedMultiCalibrationValues(null)
        }
    },[sensorCalibrationValues])

    useEffect(() => {
        if(sensorTemperatureConfigsOptions && sensorTemperatureConfigsOptions.length > 0) {
            const connectedConfig = sensorTemperatureConfigsOptions.find(x => x.currentSensorConnected)
            if(connectedConfig) {
                setSelectedTemperatureConfig(connectedConfig)
            }
        } else {
            setSelectedTemperatureConfig(null)
        }
    }, [sensorTemperatureConfigsOptions]);

    useEffect(() => {
        if(sensorColdTemperatureConfigsOptions && sensorColdTemperatureConfigsOptions.length > 0) {
            const connectedConfig = sensorColdTemperatureConfigsOptions.find(x => x.currentSensorConnected)
            if(connectedConfig) {
                setSelectedColdTemperatureConfig(connectedConfig)
            }
        } else {
            setSelectedColdTemperatureConfig(null)
        }
    }, [sensorColdTemperatureConfigsOptions]);

    const closeModal = type => {
        dispatch(toggleModal(false, type ? type : ''));
    };

    const handleDeleteSensorClick = () => {
        setDeleteConfirmation(!deleteConfirmation)
    };

    const confirmDeleteSensorClick = id => {
        dispatch(deleteSensor(id, selected.page, numberPerPage, filter, userId));
        closeModal();
    };

    const handleResetSensorClick = () => {
        setSensorResetConfirmation(!sensorResetConfirmation)
    };

    const confirmResetSensorClick = id => {
        dispatch(resetSensor(id))
        setSensorResetConfirmationMsg(true)
        setSensorResetConfirmation(false)
        setTimeout(() => setSensorResetConfirmationMsg(false), 2000)
    };

    const handleChangeLoraIdClick = () => {
        setChangeLoraModal(!changeLoraModal)
    }
    const handleChangeTimePeriodClick = () => {
        setChangeTimePeriodModal(!changeTimePeriodModal)
    }

    const handleSaveSensorTypeClick = id => {
        dispatch(saveSensorType(sensor.id, id, selected.page, numberPerPage, filter, userId));
        closeModal()
    };
    const handleSaveAlertRuleClick =   (ruleID, ruleName) => {
        dispatch(saveSensorAlertRule(sensor.id, ruleID, ruleName ));

        // closeModal()
    };
    const handleAddCommunitySensorModalClick = () => {
        dispatch(toggleModal(true, 'Add community sensor'))
    };

    const checkIfUser = () => {
        return isDemoUser() || isCustomer() || isCompanyUser();
    }

    const canManageSensorUsers = isSuperAdmin() && sensor && sensor.nodeTypeName === 'SHTTMP_SHTHUM_BLACK';
    const canCorrectRainSensorCounts = isSuperAdmin() && sensor && sensor.nodeTypeName === 'RAIN_COUNT_NO_TEMP';

    const formatUtcToLocalDateTime = (dateString) => {
        if (!dateString) return '';

        const hasTimezoneInfo = /([zZ]|[+-]\d{2}:\d{2})$/.test(dateString);
        const normalizedDateString = hasTimezoneInfo ? dateString : `${dateString}Z`;
        const date = new Date(normalizedDateString);

        if (Number.isNaN(date.getTime())) {
            return dateString;
        }

        const pad = (value) => value.toString().padStart(2, '0');

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    const handleDetachAlertRuleClick =  (ruleID) => {
        dispatch(detachSensorAlertRule(sensor.id, ruleID))
    }

    const handleSaveCalibrationValue =   (setId) => {
        dispatch(saveSensorCalibrationValue(sensor.id, setId ));
    };

    const handleDetachCalibrationValue =  (setId) => {
        dispatch(detachSensorCalibrationValue(sensor.id, setId))
    }

    const confirmSoilTypeChange = async () => {
        if (!selectedSoilType || soilTypeChangePending) return;
        setSoilTypeChangePending(true);
        setSoilTypeMessage(null);
        try {
            const updatedSensor = await dispatch(updateSensorSoilType(sensor.id, userId, selectedSoilType.soilType));
            const updatedOption = soilTypes.find(type => type.soilType === updatedSensor.soilType) || selectedSoilType;
            setSelectedSoilType(updatedOption);
            setCurrentSoilType(updatedOption.soilType);
            setSoilTypeMessage({type: 'success', text: t.gettext('Soil type was saved')});
            if (loadSensors) await loadSensors();
        } catch (error) {
            setSoilTypeMessage({type: 'error', text: t.gettext('Could not save soil type')});
        } finally {
            setSoilTypeConfirmation(null);
            setSoilTypeChangePending(false);
        }
    };

    const confirmSoilTypeRemoval = async () => {
        if (soilTypeChangePending) return;
        setSoilTypeChangePending(true);
        setSoilTypeMessage(null);
        try {
            await dispatch(removeSensorSoilType(sensor.id, userId));
            setSelectedSoilType(null);
            setCurrentSoilType(null);
            setSoilTypeMessage({type: 'success', text: t.gettext('Soil type was removed')});
            if (loadSensors) await loadSensors();
        } catch (error) {
            setSoilTypeMessage({type: 'error', text: t.gettext('Could not remove soil type')});
        } finally {
            setSoilTypeConfirmation(null);
            setSoilTypeChangePending(false);
        }
    };
    const selectMultiAlertRule = (selectedOption) => {
        if(!alertRulesSelectPending) {
            setAlertRulesSelectPending(true)
            const removedItems = selectedMultiAlertRules.filter(
                (option) => !selectedOption.find((item) => item.value === option.value)
            );
            const newlyAddedItems = selectedOption.filter(
                (option) => !selectedMultiAlertRules.find((item) => item.value === option.value)
            );
            if (newlyAddedItems.length > 0) {
                 handleSaveAlertRuleClick(newlyAddedItems[0].ruleID, newlyAddedItems[0].ruleName )
            }
            if (removedItems.length > 0) {
                handleDetachAlertRuleClick(removedItems[0].ruleID)
            }
            setSelectedMultiAlertRules(selectedOption);
            setAlertRulesSelectPending(false)
        }
    }

    const clickVapourPressure = async (vapourPressureValue) => {
        if(!vapourPressurePending) {
            setVapourPressurePending(true)
            setVapourPressure(vapourPressureValue ? vapourPressureValue : false)
            await dispatch(saveVapourPressure({sensorId: sensor.id, vapourPressure: vapourPressureValue ? vapourPressureValue : false}))
            await loadSensors()
            setVapourPressurePending(false)
        }
    }

    const selectWarmTemperatureConfig = (selectedOption) => {
        if(!temperatureConfigPending) {
            setTemperatureConfigPending(true)
            if(selectedOption) {
                dispatch(saveWarmTemperatureConfig(sensor.id, selectedOption.configId));
            } else {
                dispatch(detachWarmTemperatureConfig(sensor.id));
            }
            setSelectedTemperatureConfig(selectedOption)
            setTemperatureConfigPending(false)
        }
    }
    const selectColdTemperatureConfig = (selectedOption) => {
        if(!temperatureConfigPending) {
            setTemperatureConfigPending(true)
            if(selectedOption) {
                dispatch(saveColdTemperatureConfig(sensor.id, selectedOption.configId));
            } else {
                dispatch(detachColdTemperatureConfig(sensor.id));
            }
            setSelectedColdTemperatureConfig(selectedOption)
            setTemperatureConfigPending(false)
        }
    }

    const loadStabilityReport = async () => {
        if(!stabilityReportPending) {
            setStabilityReportPending(true)
            const stabilityReport = await dispatch(getSensorStabilityReport(sensor.id))

            if(stabilityReport) {
                setStabilityReportData(stabilityReport)
            }
            setStabilityReportPending(false)
        }
    }

    const updateMeasurements = async () => {
        if(!updateMeasurementsPending) {
            setUpdateMeasurementsPending(true)
            await dispatch(updateMeasurementsRequest(sensor.id))

            setUpdateMeasurementsPending(false)
        }
    }

    const openGatewayStats = async () => {
        setGatewayStatsModal(true)
        setGatewayStatsPending(true)
        setGatewayStatsError(false)
        setGatewayStatsData(null)

        const result = await dispatch(getSensorGatewayStats(sensor.loraIdentifier))
        if (result && !result.error) {
            setGatewayStatsData(result)
        } else {
            setGatewayStatsError(true)
        }
        setGatewayStatsPending(false)
    }

    const gatewayStats = gatewayStatsData && Array.isArray(gatewayStatsData.gatewayStats)
        ? gatewayStatsData.gatewayStats
            .map(gateway => ({
                ...gateway,
                percentage: gatewayStatsData.totalCount > 0
                    ? (Number(gateway.count) / Number(gatewayStatsData.totalCount)) * 100
                    : 0
            }))
            .sort((first, second) => second.percentage - first.percentage)
        : []

    const copyGatewayIdentifier = gatewayIdentifier => {
        copyToBuffer(gatewayIdentifier).then(copied => {
            if (copied) {
                setCopiedGatewayIdentifier(gatewayIdentifier)
                setTimeout(() => setCopiedGatewayIdentifier(null), 1200)
            }
        })
    }

    const handleRainSensorCorrectionSuccess = updatedMeasurements => {
        setRainSensorCorrectionResult(updatedMeasurements)
        setTimeout(() => setRainSensorCorrectionResult(null), 3000)
    }

    const selectMultiCalibrationValues = (selectedOption) => {
        if(!calibrationValuesPending) {
            setCalibrationValuesPending(true)
            const removedItems = selectedMultiCalibrationValues.filter(
                (option) => !selectedOption.find((item) => item.value === option.value)
            );
            const newlyAddedItems = selectedOption.filter(
                (option) => !selectedMultiCalibrationValues.find((item) => item.value === option.value)
            );
            if (newlyAddedItems.length > 0) {
                handleSaveCalibrationValue(newlyAddedItems[0].setId)
                // console.log("Added item:", ...newlyAddedItems);
            }
            if (removedItems.length > 0) {
                // console.log("Removed item:", ...removedItems);
                handleDetachCalibrationValue(removedItems[0].setId)
            }
            setSelectedMultiCalibrationValues(selectedOption);
            setCalibrationValuesPending(false)
            // setTimeout(() => setAlertRulesSelectPending(false), 5000)
        }
        // setSelectedMultiAlertRules(alertRules)
    }

    const redirectToSensorReports = () => {
        if(sensor && sensor.id) {
            history.push(`/sensor_reports?sensorId=${sensor.id}`);
        }
    }

    const StabilityReportList = ({stabilityData}) => {
        return (
            <div className="stability-wrapper">
                <h2>{t.gettext('Stability Report')}</h2>
                <div className="stability-info">
                    <div className="stability-info-row">
                        <span className="stability-info-bold">
                            {t.gettext('Status')}:
                        </span>
                        <span className="stability-info-normal">
                            {stabilityData.status || '-'}
                        </span>
                    </div>
                    <div className="stability-info-row">
                          <span className="stability-info-bold">
                            {t.gettext('Min Interval')}:
                        </span>
                        <span className="stability-info-normal">
                            {stabilityData.minInterval || '-'}
                        </span>
                    </div>
                    <div className="stability-info-row">
                          <span className="stability-info-bold">
                            {t.gettext('Max Interval')}:
                        </span>
                        <span className="stability-info-normal">
                            {stabilityData.maxInterval || '-'}
                        </span>
                    </div>
                </div>
                {stabilityData && stabilityData.measurementIntervals && stabilityData.measurementIntervals.length > 0 && (
                    <ul className="stability-list">
                        <li className="stability-header">
                        <span>{t.gettext('Measurement Time')}</span>
                            <span>{t.gettext('Interval')}</span>
                        </li>
                        <div className={'stability-list-inside'}>
                            {stabilityData?.measurementIntervals?.map((measurement, index) => (
                                <li key={index} className="stability-item">
                                    <span>{formatUtcToLocalDateTime(measurement.measurementTime)}</span>
                                    <span>{measurement.interval}</span>
                                </li>
                            ))}
                        </div>

                    </ul>
                )}
            </div>
        )
    }

    return (
        <div
            className={details ? 'sensorModalDetails' : 'sensorModalBlur'}
            onClick={e => {
                if (e.target.className === 'sensorModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className={details ? 'sensorModal inDetails' : 'sensorModal'}>
                <div className='sensorModalHeader'>
                    <div className='sensorModalTitleContainer'>
                        <div className='sensorModalTitle'>
                            {t.gettext('Sensor details')}
                        </div>
                    </div>
                    <div className='sensorModalCloseButtonHolder'>
                        <span
                            className='material-icons sensorModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div style={{overflowY: 'unset'}} className='sensorModalContent'>
                    <form className='sensorModalForm' autoComplete='off'>
                        <div className="sensorButtonsGrid">
                            {(isCompanyAdmin() || isSuperAdmin()) && (
                                <>
                                    <button
                                        className='sensorAddButton sensorDeleteButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleDeleteSensorClick();
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Delete Sensor')}
                                    </button>
                                    <button
                                        className='sensorAddButton sensorResetButton'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleResetSensorClick();
                                        }}
                                        disabled={disableButtons}
                                    >
                                        {t.gettext('Reset Sensor')}
                                    </button>
                                </>
                            )}
                            {isSuperAdmin() && (
                                <button
                                    className='sensorAddButton sensorAddButton--communitySensor'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleAddCommunitySensorModalClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Add Community Sensor')}
                                </button>
                            )}
                            {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer() || isCompanyUser()) && (
                                <button
                                    style={{background: 'dodgerblue', color: "#fff"}}
                                    className='sensorAddButton sensorAddButton--communitySensor'
                                    onClick={e => {
                                        e.preventDefault();
                                        redirectToSensorReports();
                                    }}
                                >
                                    {t.gettext('Sensor Reports')}
                                </button>
                            )}
                            {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer() || isCompanyUser()) && (
                                <button
                                    className='sensorAddButton sensorAddButton--measurementsTime'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleChangeTimePeriodClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Measurements upload time')}
                                </button>
                            )}
                            <button
                                style={{background: 'dodgerblue', color: "#fff",}}
                                className='sensorAddButton sensorAddButton--measurementsTime'
                                onClick={e => {
                                    e.preventDefault();
                                    loadStabilityReport();
                                }}
                                disabled={disableButtons}
                            >
                                {t.gettext('Stability Report')}
                            </button>
                            {isSuperAdmin() && (
                                <button
                                    className='sensorAddButton sensorGatewaysButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        openGatewayStats();
                                    }}
                                    disabled={disableButtons || !sensor || !sensor.loraIdentifier}
                                >
                                    {t.gettext('Gateways')}
                                </button>
                            )}
                            <button
                                style={{background: '#22bf00', color: "#fff",}}
                                className='sensorAddButton sensorAddButton--measurementsTime'
                                onClick={e => {
                                    e.preventDefault();
                                    updateMeasurements();
                                }}
                                disabled={disableButtons}
                            >
                                {t.gettext('Load Recent Measurements')}
                                {updateMeasurementsPending && (
                                    <ButtonSpinner />
                                )}
                            </button>
                            {canManageSensorUsers && (
                                <button
                                    className='sensorAddButton sensorUsersAccessButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        setSensorUsersAccessModal(true);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Add users')}
                                </button>
                            )}
                            {canCorrectRainSensorCounts && (
                                <button
                                    className='sensorAddButton sensorAddButton--countsCorrection'
                                    onClick={e => {
                                        e.preventDefault();
                                        setRainSensorCorrectionModal(true);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Counts correction')}
                                </button>
                            )}
                        </div>
                        {deleteConfirmation &&
                            <div className='sensorDeleteConfirmation'>
                                {sensor.name + ' ' + t.gettext('will be deleted')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmDeleteSensorClick(sensor.id);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteSensorClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }
                        {sensorResetConfirmation &&
                            <div className='sensorDeleteConfirmation'>
                                {sensor.name + ' ' + t.gettext('will be reset')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmResetSensorClick(sensor.id);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleResetSensorClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }
                        {stabilityReportData && (
                            <StabilityReportList
                                stabilityData={stabilityReportData}
                            />
                        )}
                        <div className='sensorModalFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Sensor Type')}
                            </label>
                            <div className='sensorModalFormRow'>
                                <div
                                    className='sensorModalFormSelect'
                                    onClick={!isDistributorAdmin() && !checkIfUser() ? () => setShowSensorTypeOptions(!showSensorTypeOptions) : null}
                                >
                                    <div className='sensorModalFormSelectText'>
                                        {sensorType.name}
                                    </div>
                                    {!isDistributorAdmin() && !checkIfUser() &&
                                        <i className="material-icons dropDownIcon">
                                            {showSensorTypeOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                        </i>
                                    }
                                    {showSensorTypeOptions &&
                                        <div className='sensorModalFormSelectOptions'>
                                            {sensorTypes.map((item, index) => (
                                                <div
                                                    className='sensorModalFormSelectOption'
                                                    key={index}
                                                    onClick={() => setSensorType({name: item.name, id: item.id})}
                                                >
                                                    {item.name}
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                                {(isSuperAdmin() || isCompanyAdmin()) &&
                                    <span
                                        className='material-icons saveIcon'
                                        onClick={e => {
                                            e.preventDefault();
                                            handleSaveSensorTypeClick(sensorType.id);
                                        }}
                                    >
                                    save
                                </span>
                                }
                            </div>
                        </div>
                        {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) && sensor.hasOwnProperty('vapourPressure') && sensorType && sensorType.name === 'SHTTMP_SHTHUM_BLACK' && (
                            <div style={{margin: 'unset'}} className="sensorModalFormItem">
                                <div className="checkboxWrapper">
                                    <span>{t.gettext('Vapour pressure check')}:</span>
                                    <label className='checkboxContainer'>
                                        <input type="checkbox"
                                               onChange={e => clickVapourPressure(!sensor.vapourPressure)}
                                               checked={vapourPressure}
                                        />
                                        <span className="checkMark"/>
                                    </label>
                                </div>
                            </div>
                        )}
                        {sensorTemperatureConfigsOptions && sensorTemperatureConfigsOptions.length > 0 && (
                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Rising Hours')}
                                </label>
                                <div style={{padding: '10px 0'}}>
                                    <Select
                                        options={sensorTemperatureConfigsOptions}
                                        isDisabled={sensorsDetailsPending}
                                        // isMulti
                                        isClearable={true}
                                        maxMenuHeight={200}
                                        placeholder={t.gettext('Select...')}
                                        styles={customStyles}
                                        onChange={selectWarmTemperatureConfig}
                                        value={selectedTemperatureConfig}
                                        noOptionsMessage={() => t.gettext('No options')}
                                    />
                                </div>
                            </div>
                        )}
                        {sensorColdTemperatureConfigsOptions && sensorColdTemperatureConfigsOptions.length > 0 && (
                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Cold Hours')}
                                </label>
                                <div style={{padding: '10px 0'}}>
                                    <Select
                                        options={sensorColdTemperatureConfigsOptions}
                                        isDisabled={sensorsDetailsPending}
                                        // isMulti
                                        isClearable={true}
                                        maxMenuHeight={200}
                                        placeholder={t.gettext('Select...')}
                                        styles={customStyles}
                                        onChange={selectColdTemperatureConfig}
                                        value={selectedColdTemperatureConfig}
                                        noOptionsMessage={() => t.gettext('No options')}
                                    />
                                </div>
                            </div>
                        )}


                        <div className='sensorModalFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Alert Rules')}
                            </label>
                            <div style={{padding: '10px 0'}}>
                                <Select
                                    options={sensorAlertRulesOptions}
                                    isDisabled={sensorsDetailsPending}
                                    isMulti
                                    isClearable={false}
                                    maxMenuHeight={200}
                                    placeholder={t.gettext('Select...')}
                                    styles={customStyles}
                                    onChange={selectMultiAlertRule}
                                    value={selectedMultiAlertRules}
                                    noOptionsMessage={() => t.gettext('No options')}
                                />
                            </div>
                        </div>
                        <div className='sensorModalFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Calibration Values')}
                            </label>
                            <div style={{padding: '10px 0'}}>
                                <Select
                                    options={sensorCalibrationValues}
                                    isDisabled={sensorsCalibrationDetailsPending}
                                    isMulti
                                    isClearable={false}
                                    maxMenuHeight={200}
                                    placeholder={t.gettext('Select...')}
                                    styles={customStyles}
                                    onChange={selectMultiCalibrationValues}
                                    value={selectedMultiCalibrationValues}
                                    noOptionsMessage={() => t.gettext('No options')}
                                />
                            </div>
                        </div>
                        {isSoilMoistureSensor && (
                            <div className='sensorModalFormItem sensorModalFormItem--soilType'>
                                <label className='sensorModalFormLabel'>{t.gettext('Soil type')}</label>
                                <div className='soilTypeControl'>
                                    <Select
                                        className='soilTypeSelect'
                                        options={soilTypes}
                                        isDisabled={soilTypesPending || soilTypeChangePending}
                                        isClearable={false}
                                        maxMenuHeight={200}
                                        placeholder={t.gettext('Select...')}
                                        styles={customStyles}
                                        onChange={option => {
                                            setSelectedSoilType(option);
                                            setSoilTypeConfirmation(null);
                                            setSoilTypeMessage(null);
                                        }}
                                        value={selectedSoilType}
                                        noOptionsMessage={() => t.gettext('No options')}
                                    />
                                    <button
                                        className='material-icons soilTypeActionIcon soilTypeActionIcon--save'
                                        type='button'
                                        title={t.gettext('Save')}
                                        aria-label={t.gettext('Save')}
                                        disabled={!selectedSoilType || selectedSoilType.soilType === currentSoilType || soilTypesPending || soilTypeChangePending}
                                        onClick={() => setSoilTypeConfirmation('save')}
                                    >save</button>
                                    {currentSoilType && (
                                        <button
                                            className='material-icons soilTypeActionIcon soilTypeActionIcon--remove'
                                            type='button'
                                            title={t.gettext('Remove soil type')}
                                            aria-label={t.gettext('Remove soil type')}
                                            disabled={soilTypeChangePending}
                                            onClick={() => setSoilTypeConfirmation('remove')}
                                        >delete</button>
                                    )}
                                </div>
                                {soilTypeConfirmation && (
                                    <div className='soilTypeConfirmation'>
                                        <span>{soilTypeConfirmation === 'save'
                                            ? t.gettext('Are you sure you want to change the soil type?')
                                            : t.gettext('Are you sure you want to remove the soil type?')}</span>
                                        <button type='button' disabled={soilTypeChangePending} onClick={soilTypeConfirmation === 'save' ? confirmSoilTypeChange : confirmSoilTypeRemoval}>{t.gettext('OK')}</button>
                                        <button type='button' disabled={soilTypeChangePending} onClick={() => setSoilTypeConfirmation(null)}>{t.gettext('Cancel')}</button>
                                    </div>
                                )}
                                {soilTypeMessage && (
                                    <div className={`soilTypeMessage soilTypeMessage--${soilTypeMessage.type}`}>{soilTypeMessage.text}</div>
                                )}
                            </div>
                        )}

                        {/*<div className='sensorModalFormItem'>*/}
                        {/*    <label className='sensorModalFormLabel'>*/}
                        {/*        {t.gettext('Alert Rule')}*/}
                        {/*    </label>*/}
                        {/*    <div className='sensorModalFormRow'>*/}
                        {/*        <div*/}
                        {/*            className='sensorModalFormSelect'*/}
                        {/*            onClick={(!isDistributorAdmin() && !isDemoUser()) ? () => setShowAlertRulesOptions(!showAlertRulesOptions) : null}*/}
                        {/*        >*/}
                        {/*            <div className='sensorModalFormSelectText'>*/}
                        {/*                {alertRule?.ruleName}*/}
                        {/*            </div>*/}
                        {/*            {(!isDistributorAdmin() && !isDemoUser()) &&*/}
                        {/*                <i className="material-icons dropDownIcon">*/}
                        {/*                    {showAlertRulesOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}*/}
                        {/*                </i>*/}
                        {/*            }*/}
                        {/*            {showAlertRulesOptions &&*/}
                        {/*                <div className='sensorModalFormSelectOptions'>*/}
                        {/*                    {sensorAlertRules?.map((item, index) => (*/}
                        {/*                        <div*/}
                        {/*                            className='sensorModalFormSelectOption'*/}
                        {/*                            key={index}*/}
                        {/*                            onClick={() => setAlertRule({ruleName: item.ruleName, ruleID: item.ruleID})}*/}
                        {/*                        >*/}
                        {/*                            {item.ruleName}*/}
                        {/*                        </div>*/}
                        {/*                    ))}*/}
                        {/*                </div>*/}
                        {/*            }*/}
                        {/*        </div>*/}
                        {/*        {(!isDistributorAdmin() && !isDemoUser()) &&*/}
                        {/*            <span*/}
                        {/*                className='material-icons saveIcon'*/}
                        {/*                onClick={e => {*/}
                        {/*                    e.preventDefault();*/}
                        {/*                    handleSaveAlertRuleClick(alertRule.ruleID, alertRule.ruleName);*/}
                        {/*                }}*/}
                        {/*            >*/}
                        {/*            save*/}
                        {/*        </span>*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="oneRowContainer">
                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Sensor Name')}
                                </label>
                                <div className='sensorModalFormInput'>
                                    {sensor ? sensor.name : ''}
                                </div>
                            </div>
                            {isSuperAdmin() &&
                                <span
                                    className='material-icons changeLora'
                                    onClick={e => {
                                        e.preventDefault();
                                        setEditSensorModal({active: true, type: 'name'})
                                    }}
                                >
                                    save
                                </span>
                            }
                        </div>
                        <div className="oneRowContainer">
                            <div className="latLonContainer">
                                <div className='sensorModalFormItem'>
                                    <label className='sensorModalFormLabel'>
                                        {t.gettext('Latitude')}
                                    </label>
                                    <div className='sensorModalFormInput'>
                                        {sensor ? sensor?.lat : ''}
                                    </div>
                                </div>
                                <div className='sensorModalFormItem'>
                                    <label className='sensorModalFormLabel'>
                                        {t.gettext('Longitude')}
                                    </label>
                                    <div className='sensorModalFormInput'>
                                        {sensor ? sensor?.lon : ''}
                                    </div>
                                </div>
                            </div>
                            {isSuperAdmin() &&
                                <span
                                    className='material-icons changeLora'
                                    onClick={e => {
                                        e.preventDefault();
                                        setEditSensorModal({active: true, type: 'geo'})
                                    }}
                                >
                                    save
                                </span>
                            }
                        </div>


                        <div className="oneRowContainer">
                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Sensor Id')}
                                </label>
                                <div className='sensorModalFormInput'>
                                    {sensor ? sensor.id : ''}
                                </div>
                            </div>

                            <div className='sensorModalFormItem'>
                                <label className='sensorModalFormLabel'>
                                    {t.gettext('Is Active')}
                                </label>
                                <div className='sensorModalFormInput'>
                                    {!sensor ? '' : sensor.active
                                        ? <span
                                            className='material-icons iconTrue'
                                        >
                                        check_circle
                                    </span>
                                        : <span
                                            className='material-icons iconFalse'
                                        >
                                        cancel
                                    </span>
                                    }
                                </div>
                            </div>

                            {!checkIfUser() && (
                                <Fragment>
                                    <div className='sensorModalFormItem'>
                                        <label className='sensorModalFormLabel'>
                                            {t.gettext('Lora Identifier')}
                                        </label>
                                        <div className='sensorModalFormInput'>
                                            {sensor ? sensor.loraIdentifier : ''}
                                        </div>
                                    </div>
                                    {isSuperAdmin() &&
                                        <span
                                            className='material-icons changeLora'
                                            onClick={e => {
                                                e.preventDefault();
                                                setChangeLoraModal(true)
                                            }}
                                        >
                                    save
                                </span>
                                    }
                                </Fragment>

                            )}
                        </div>
                        <div className='sensorModalFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('User Name')}
                            </label>
                            <div className='sensorModalFormInput'>
                                {sensor ? sensor.userName : ''}
                            </div>
                        </div>
                        <div className='sensorModalFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('User Email')}
                            </label>
                            <div className='sensorModalFormInput'>
                                {sensor ? sensor.userEmail : ''}
                            </div>
                        </div>
                        <div className='sensorModalFormItem'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Field Name')}
                            </label>
                            <div className='sensorModalFormInput'>
                                {sensor && sensor.fieldName ? sensor.fieldName : ''}
                                {/*{sensor ? fields.find(x => x.id === sensor.fieldId)?.fieldName : ''}*/}
                            </div>
                        </div>
                        <div className='sensorModalFormItem sensorModalFormItem--large'>
                            <label className='sensorModalFormLabel'>
                                {t.gettext('Last Measurement')}
                            </label>
                            {sensor && sensor.measurements.length
                                ? <div className='fieldSensorsListItem'>
                                    <div
                                        className='fieldSensorsListItemStatusColorBar'
                                        style={{background: getStatusColor(sensor.temperatureStatus)}}
                                    />
                                    <div className='fieldSensorDetails'>
                                        <div className='fieldSensorDetail'>
                                            {t.gettext('Measurement Time') + ' : '}
                                            <span>{formatUtcToLocalDateTime(sensor.measurements[0].dateTimeCreated)}</span>
                                        </div>
                                        {/*{!checkIfUser() && (*/}
                                        <Fragment>
                                            <div className='fieldSensorDetail'>
                                                {t.gettext('Temperature') + ' : '}
                                                <span>{sensor.temperature + ' '} &#8451;</span>
                                            </div>
                                            <div className='fieldSensorDetail'>
                                                {t.gettext('Humidity') + ' : '}
                                                <span>{sensor.measurements[0].humidity + ' '} %</span>
                                            </div>
                                            <div className='fieldSensorDetail'>
                                                {t.gettext('Battery') + ' : '}
                                                <span>{sensor?.battery + ' '} V</span>
                                            </div>
                                        </Fragment>
                                        {/*)}*/}
                                    </div>
                                </div>
                                : <div className='sensorModalFormInput'>
                                    {t.gettext('No measurements')}
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
            {sensorResetConfirmationMsg && (
                <ExternalModal
                    messageModal
                >
                    <div className='sensorResetMsg'>{t.gettext('The soft reset command will be sent to sensor')}</div>
                </ExternalModal>
            )}
            {changeLoraModal && (
                <ExternalModal
                    messageModal
                >
                    <ChangeLoraIdModal
                        closeMethod={handleChangeLoraIdClick}
                        itemsPerPage={numberPerPage}
                        filter={filter}
                        search={''}
                        reload={reload}
                    />
                </ExternalModal>
            )}
            {changeTimePeriodModal && (
                <ExternalModal
                    messageModal
                >
                    <ChangeTimePeriodModal
                        closeMethod={handleChangeTimePeriodClick}
                    />
                </ExternalModal>
            )}
            {editSensorModal.active && editSensorModal.type && (
                <ExternalModal
                    messageModal
                >
                    <EditSensorModal
                        itemsPerPage={numberPerPage}
                        filter={filter}
                        // search={}
                        loadSensors={loadSensors}
                        reload={reload}
                        editType={editSensorModal.type}
                        closeMethod={() => setEditSensorModal({active: false})}
                        />
                </ExternalModal>
            )}
            {rainSensorCorrectionModal && sensor && sensor.id && (
                <ExternalModal
                    title={t.gettext('Rain sensor count correction')}
                    closeMethod={() => setRainSensorCorrectionModal(false)}
                >
                    <RainSensorCountCorrectionModal
                        sensor={sensor}
                        closeMethod={() => setRainSensorCorrectionModal(false)}
                        onSuccess={handleRainSensorCorrectionSuccess}
                    />
                </ExternalModal>
            )}
            {rainSensorCorrectionResult !== null && (
                <ExternalModal
                    messageModal
                >
                    <div className='rainSensorCorrectionResult'>
                        {t.gettext('Updated measurements')}: {rainSensorCorrectionResult}
                    </div>
                </ExternalModal>
            )}
            {sensorUsersAccessModal && sensor && sensor.id && (
                <UserAccessModal
                    t={t}
                    itemId={sensor.id}
                    idKey='sensorId'
                    getEndpoint='sensor_users/getUsersForSensor'
                    setEndpoint='sensor_users/setUsersForSensor'
                    closeMethod={() => setSensorUsersAccessModal(false)}
                />
            )}
            {gatewayStatsModal && (
                <ExternalModal
                    title={t.gettext('Gateway connection statistics')}
                    closeMethod={() => setGatewayStatsModal(false)}
                >
                    <div className='gatewayStatsModal'>
                        <div className='gatewayStatsSensor'>
                            <span>{t.gettext('Sensor')}</span>
                            <strong>{sensor.loraIdentifier}</strong>
                        </div>
                        {gatewayStatsPending && (
                            <div className='gatewayStatsState'>
                                <ButtonSpinner />
                                <span>{t.gettext('Loading connection statistics')}</span>
                            </div>
                        )}
                        {!gatewayStatsPending && gatewayStatsError && (
                            <div className='gatewayStatsState gatewayStatsState--error'>
                                {t.gettext('Unable to load connection statistics')}
                            </div>
                        )}
                        {!gatewayStatsPending && !gatewayStatsError && gatewayStats.length === 0 && (
                            <div className='gatewayStatsState'>
                                {t.gettext('no connection statistics')}
                            </div>
                        )}
                        {!gatewayStatsPending && !gatewayStatsError && gatewayStats.length > 0 && (
                            <div className='gatewayStatsList'>
                                {gatewayStats.map(gateway => (
                                    <div className='gatewayStatsItem' key={gateway.gatewayIdentifier}>
                                        <div className='gatewayStatsItemHeader'>
                                            <div className='gatewayStatsIdentifierHolder'>
                                                <span className='gatewayStatsIdentifier'>{gateway.gatewayIdentifier}</span>
                                                <button
                                                    type='button'
                                                    className={copiedGatewayIdentifier === gateway.gatewayIdentifier
                                                        ? 'gatewayStatsCopyButton gatewayStatsCopyButton--copied'
                                                        : 'gatewayStatsCopyButton'
                                                    }
                                                    onClick={() => copyGatewayIdentifier(gateway.gatewayIdentifier)}
                                                    title={t.gettext('Copy to buffer')}
                                                    aria-label={t.gettext('Copy to buffer')}
                                                >
                                                    <span className='material-icons'>
                                                        {copiedGatewayIdentifier === gateway.gatewayIdentifier ? 'check' : 'content_copy'}
                                                    </span>
                                                </button>
                                            </div>
                                            <strong>{gateway.percentage.toFixed(1)}%</strong>
                                        </div>
                                        <div className='gatewayStatsProgress' aria-hidden='true'>
                                            <span style={{width: `${Math.min(gateway.percentage, 100)}%`}} />
                                        </div>
                                        <div className='gatewayStatsCount'>
                                            {gateway.count} / {gatewayStatsData.totalCount} {t.gettext('connections')}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </ExternalModal>
            )}
        </div>
    );
};

export default SensorModal;
